import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import { CalendarList, CalendarListFetchOptions } from "~/api/types/CalendarList"
import { Event } from "~/api/types/Event"
import { Breadcrumbs } from "~/components/Breadcrumbs/Breadcrumbs"
import { EventCard } from "~/components/EventCard/EventCard"
import { EmptyFilter } from "~/components/FilterWrapper/components/EmptyFilter/EmptyFilter"
import { FilterPreloaderWrapper } from "~/components/FilterWrapper/components/PreloaderWrapper/PrealoderWrapper"
import { ShowMore } from "~/components/FilterWrapper/components/ShowMore/ShowMore"
import { StatusFilter } from "~/components/FilterWrapper/components/StatusFilter/StatusFilter"
import { FilterWrapper, useFilterContext } from "~/components/FilterWrapper/FilterWrapper"
import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"
import { groupBy } from "~/helpers/groupBy"

import styles from "./index.module.css"

export const List: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className="container">
      <Breadcrumbs />

      <Heading as="h2" className={styles.Title} like="h1">
        <Raw html={t("calendar.Title")} />
      </Heading>

      <FilterWrapper url={"/calendar/list"}>
        {({ items }) => {
          const filteredItems = items.filter((value) => value.id !== "66135")

          return (
            <>
              <div className={styles.Filters}>
                <StatusFilter
                  activeLabel={t("calendar.Filter.Status.Active")}
                  closedLabel={t("calendar.Filter.Status.Closed")}
                />
              </div>

              {filteredItems.length === 0 ? (
                <EmptyFilter />
              ) : (
                <>
                  <FilterPreloaderWrapper>
                    <EventsList items={filteredItems} />
                  </FilterPreloaderWrapper>
                  <ShowMore />
                </>
              )}
            </>
          )
        }}
      </FilterWrapper>
    </div>
  )
}

const EventsList: React.FC<{ items: Event[] }> = ({ items }) => {
  const { filterState, isLoading } = useFilterContext()
  const [state, setState] = useState(filterState)

  // меняем state только после завершения загрузки данных
  useEffect(() => {
    if (isLoading) {
      return
    }

    setState(filterState)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading])

  return state.status === "active" ? (
    <Events items={items} />
  ) : (
    <EventsByYear items={items} status={filterState.status} />
  )
}

const Events: React.FC<{ items: Event[] }> = ({ items }) => (
  <div className={styles.Items}>
    {items.map((item, i) => (
      <EventCard key={i} {...item} />
    ))}
  </div>
)

const EventsByYear: React.FC<{ items: Event[]; status: CalendarListFetchOptions["status"] }> = ({
  items,
  status,
}) => {
  const events = items.map((item) => {
    const clearDate = item.date.toString().split(" ")[0]
    const year = new Date(clearDate).getFullYear()

    return { ...item, year }
  })

  const eventsByYear: { year: number; items: CalendarList["items"] }[] = groupBy(events, "year")

  return (
    <>
      {eventsByYear.map(({ items, year }, i) => (
        <div key={i} className={styles.ItemsByYear}>
          <Heading className={styles.Year} like="h2">
            {year}
          </Heading>
          <div key={i} className={styles.Items}>
            {items.map((item, i) => (
              <EventCard key={i} {...item} displayActivity={status === undefined} />
            ))}
          </div>
        </div>
      ))}
    </>
  )
}
